import { render, staticRenderFns } from "./manifestApproval.vue?vue&type=template&id=7ea3b470&"
import script from "./manifestApproval.vue?vue&type=script&lang=js&"
export * from "./manifestApproval.vue?vue&type=script&lang=js&"
import style0 from "./manifestApproval.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports